export const PhoneIcon = ({
  width = 26,
  height = 26,
  className,
  title = "Phone",
  ...rest
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      className={className}
      {...rest}>
      <title>{title}</title>
      <path
        d="M13.4928 9.28646L10.442 6.03666C10.0736 5.6442 9.463 5.61468 9.07451 5.98729C8.10329 6.9188 6.39835 8.68228 5.70525 10.1919C4.71007 12.3596 7.16643 18.6834 10.8614 22.0686C14.5564 25.4537 20.2608 27.4309 21.9007 26.3873C23.0223 25.6735 24.7695 24.1681 25.7615 23.288C26.1796 22.9172 26.2015 22.2764 25.8166 21.8713L22.808 18.7048C22.3521 18.225 21.5508 18.3062 21.1182 18.8071C20.5264 19.4924 19.6489 20.2867 18.6616 20.449C16.859 20.7453 15.7328 19.5638 14.3428 18.2896C12.9528 17.0155 11.3473 15.2336 11.6436 13.431C11.8104 12.4163 12.6447 11.5176 13.3422 10.9258C13.8289 10.5129 13.9296 9.75179 13.4928 9.28646Z"
        stroke="currentColor"
        strokeLinejoin="round"
      />
    </svg>
  );
};
